﻿import { ParameterSchemaStation } from "../../API/Schema/ParameterSchema";
import { IUnitsConversionSet } from "../../Converters/UnitsConverter/IUnitsConverter";
import { ILiveDataListenerContext, ILiveDataListener } from "../../ILiveDataListener";
import { MainSite } from "../../MainSite";
import { WarningGroup } from "../../Model/WarningGroup";
import { Profile, ProfileComponent } from "../../ValueTypes/Profile";
import { SpeedUnits } from "./Current";
import { HovmollerChart, ChartDataPoint } from "./HovmollerChart";
import { ISiteObservationsPage } from "./ISiteObservationsPage";
import { ProfileChart, ProfileTypeEnum } from "./ProfileChart";

export class WindProfile implements ISiteObservationsPage {

    public id: string = 'wind_profile';
    public label: string = 'Wind Profile';

    public station: ParameterSchemaStation;
    public warningGroup: WarningGroup;

    private _chartsHovmoller: HovmollerChart;
    private windProfileSensor?: string = null; //: for Color Flood chart..
    private windProfileParam?: string = null; //: for Color Flood chart..

    public notifyResize() {
    }

    public show(station: ParameterSchemaStation): boolean {
        this.windProfileSensor = null;
        this.windProfileParam = null;

        for (let sensorId in station.Sensors) {
            const sensor = station.Sensors[sensorId];

            for (let paramId in sensor.Parameters) {
                if (paramId.indexOf('WindProfile_mps') != -1) {
                    this.windProfileSensor = sensorId;
                    this.windProfileParam = paramId;
                    return true;
                }
            }
        }
        return false;
    }

    constructor(public mainSite: MainSite, private ctx: ILiveDataListenerContext) {
    }

    public render(container: JQuery, listeners: ILiveDataListener[], station: ParameterSchemaStation, warningGroup: WarningGroup): void {
        this.station = station;
        this.warningGroup = warningGroup;

        let showChart = (chartType: string) => {
            $('.site-obs-windprofile-charts').hide();
            $(`.site-obs-windprofile-charts[data-chart-type="${chartType}"]`).show();
            MainSite.instance.dispatchResize();
        };


        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');

        var rightPanel = $('<div style="position: relative; width: 100%; height: 100%;"></div>')
            .appendTo(page);

        let chartSelectTabs = $('<div class="current_chart_selector"></div>')
            .appendTo(rightPanel);

        let tpul = $('<ul></ul>')
            .append($('<span></span>').text("Chart: "))
            .appendTo(chartSelectTabs);

        tpul.append($('<li></li>')
            .addClass('selected')
            .text("Wind Profile")
            .click((ev) => {
                tpul.children('li').removeClass('selected');
                $(ev.target).addClass("selected");
                showChart('wind-profile');
            }));

        tpul.append($('<li></li>')
            .text("Color Flood")
            .click((ev) => {
                tpul.children('li').removeClass('selected');
                $(ev.target).addClass("selected");
                showChart('hovmoller');
            }));


        let currentBox = $('<div class="site-obs-windprofile-charts" data-chart-type="wind-profile"></div>').appendTo(rightPanel);
        let hovmollerBox = $('<div class="site-obs-windprofile-charts" data-chart-type="hovmoller"><em class="text-muted">Loading Color Flood chart...</em></div>').appendTo(rightPanel).hide();

        MainSite.instance.dispatchResize();

        listeners.push(
            new ProfileChart(this,
                currentBox,
                5, 0, 95, 100,
                SpeedUnits.mps, "Wind", ProfileTypeEnum.Height));


        //: get unitConversionSet's and factors (ucf_ prefixed vars = "unit conversion factor"):
        var speedUnitsStr = 'm/s';
        var unitsStrDepthOrHeight = 'm';
        let unitsConversionSet_DepthOrHeight: IUnitsConversionSet | null = MainSite.getUnitConverter().getConversionSet('m');
        let unitsConversionSet_Speed: IUnitsConversionSet | null = MainSite.getUnitConverter().getConversionSet(speedUnitsStr);
        let ucf_DepthOrHeight: (value: any) => any = (value: any) => value;
        let ucf_Speed: (value: any) => any = (value: any) => value;
        if (unitsConversionSet_DepthOrHeight) {
            ucf_DepthOrHeight = unitsConversionSet_DepthOrHeight.convertValue;
            unitsStrDepthOrHeight = unitsConversionSet_DepthOrHeight.convertedUnits;
        }
        if (unitsConversionSet_Speed) {
            ucf_Speed = unitsConversionSet_Speed.convertValue;
            speedUnitsStr = unitsConversionSet_Speed.convertedUnits;
        }

        // Speed: Options specific to speed chart
        let hovmolOptionsSpeed: __Highcharts.Options = HovmollerChart.chartOptionsDefault();
        hovmolOptionsSpeed.tooltip = {
            headerFormat: `Speed (${speedUnitsStr})<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`, //: https://highcharts.com/class-reference/Highcharts.Time#dateFormat
        };
        hovmolOptionsSpeed.yAxis = {
            ...hovmolOptionsSpeed.yAxis,
            title: {
                text: `Height (${unitsStrDepthOrHeight})`
            },
        };
        hovmolOptionsSpeed.colorAxis = {
            ...hovmolOptionsSpeed.colorAxis,
            stops: [
                // Jet colorscheme
                [0, '#0000FF'], // Blue
                [0.33, '#00FFFF'], // Cyan
                [0.66, '#FFFF00'], // Yellow
                [1, '#FF0000'] // Red
            ],
        };

        // Direction: Options specific to direction chart
        let hovmolOptionsDirection: __Highcharts.Options = HovmollerChart.chartOptionsDefault();
        hovmolOptionsDirection.tooltip = {
            headerFormat: `Direction (deg)<br/>`,
            pointFormat: `{point.x:%d/%m/%Y %H:%M} (<em>{point.y:.1f}${unitsStrDepthOrHeight}</em>): <b>{point.value:.1f}</b>`, //: https://highcharts.com/class-reference/Highcharts.Time#dateFormat
        };
        hovmolOptionsDirection.yAxis = {
            ...hovmolOptionsSpeed.yAxis,
            title: {
                text: `Height (${unitsStrDepthOrHeight})`
            },
        };
        hovmolOptionsDirection.colorAxis = {
            ...hovmolOptionsDirection.colorAxis,
            stops: [
                [0.0, 'rgb(255, 0, 0)'],
                [0.25, 'rgb(160, 32, 240)'],
                [0.5, 'rgb(0, 0, 255)'],
                [0.75, 'rgb(252, 186, 3)'],
                [1.0, 'rgb(255, 0, 0)'],
            ],
            //tickInterval: 180,
            tickPositions: [0, 90, 180, 270, 360],
            startOnTick: true,
            endOnTick: true,
        };

        this._chartsHovmoller = new HovmollerChart(
            this.mainSite,
            this,
            hovmollerBox,
            0, 0, 93, 100,
            //// specific chart options
            hovmolOptionsSpeed,
            hovmolOptionsDirection,
            //// getDataMethod
            (tsFrom: moment.Moment, tsTo: moment.Moment, isSpeed: boolean, extractProfileCmpValue: (cp: ProfileComponent) => number, chart: HovmollerChart, callback: (data: ChartDataPoint[], isFailed: boolean) => void): void => {
                let res: ChartDataPoint[] = [];

                /*if (!this.mainSite.liveDataManager.latestData) {
                    console.warn('Current Hovmoller chart: waiting for live data..');
                    callback([], true);
                    return;
                }*/

                if (this.windProfileSensor == null || this.windProfileParam == null) {
                    console.warn('Wind Hovmoller chart: no wind profile sensor or param detected for this station.');
                    callback([], false);
                    return;
                }

                let sensor = this.windProfileSensor;
                let parameter = this.windProfileParam;
                let uri = `/api/v1/HistoricalData/P/${this.station.Station.Id}/${sensor}/${parameter}?fromUnixMillis=${tsFrom.valueOf()}&toUnixMillis=${tsTo.valueOf()}`;
                console.info('Wind Hovmoller - data fetch URI:', uri);

                $.ajax(uri + '', {
                    cache: false,
                    dataType: 'json',
                    type: 'GET',
                    timeout: 30000,
                    success: (data: any, text: string, jqXHR: JQueryXHR) => {
                        try {
                            console.info('Wind obs - Color Flood chart data (RAW)', data);

                            if (Array.isArray(data.results[0].series[0].values)) {
                                for (let i = 0; i < data.results[0].series[0].values.length; i++) {
                                    let x = data.results[0].series[0].values[i];
                                    let m: moment.Moment = moment.utc(x[0], "YYYY-MM-DD HH:mm:ssZ", true);
                                    if (m && m.isValid()) {
                                        let profile = JSON.parse(x[1]) as Profile;

                                        let components = profile.Components.sort((a, b) => b.Height - a.Height); //: TODO: check sorting!!
                                        components.forEach((cp, cpi) => {
                                            if (!cp.Speed || isNaN(cp.Speed)) {
                                                return;
                                            }
                                            res.push({
                                                timestamp: m.valueOf(),
                                                y: ucf_DepthOrHeight(cp.Height),
                                                val: isSpeed ? ucf_Speed(cp.Speed) : cp.Direction,
                                            });
                                        });
                                    } else {
                                        console.warn("Unable to parse " + this.windProfileParam + " Profile Data from server response. Error: Timestamp not parseable to a valid Moment.");
                                        // this.drawChartMessage("Error while retrieving " + this.profileName + " Profile Data.");
                                    }
                                }

                                console.info('Current obs - Color Flood chart data', res);
                                callback(res, false);
                            }
                        } catch (err) {
                            console.warn("Unable to parse " + this.windProfileParam + " Profile Data from server response. Error: ", err);
                            callback([], true);
                        }
                    },
                    error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
                        console.warn("Unable to parse " + this.windProfileParam + " Profile Data from server response. Error: ", errorThrown);
                        callback([], true);
                    }
                });
            },
        );
        listeners.push(this._chartsHovmoller);

        page.appendTo(container);
        MainSite.instance.dispatchResize();
    }
}